import React from 'react';
import { CardBody, CardTitle, CardText, Button } from 'reactstrap';

const MyDetails = (props) => {
  const { auth } = props;
  const { userName, email } = auth;
  return (
    <>
      <Button className="user-edit-btn" size="sm" color="primary">
        <i className="fa fa-edit" />
      </Button>
      <CardBody>
        <div className="d-flex flex-wrap align-items-center position-relative">
          <img
            src="https://image.flaticon.com/icons/png/512/147/147144.png"
            className="user-img"
            alt={userName}
            width="120"
            height="120"
          />
          <div className="img-camera-icon">
            <i className="fa fa-camera" />
          </div>
          <div>
            <CardTitle className="text-uppercase">{userName}</CardTitle>
            <CardText>Admin</CardText>
          </div>
        </div>
      </CardBody>
      <CardBody className="border-top">
        <small className="text-uppercase text-muted">Email address: </small>
        <h6>{email}</h6>
        <br />
        <small className="text-uppercase text-muted">Phone: </small>
        <h6>+91 654 784 547</h6>
        <br />
        <small className="text-uppercase text-muted">Address: </small>
        <h6>71 Pilgrim Avenue Chevy Chase, MD 20815</h6>
      </CardBody>
    </>
  );
};

export default MyDetails;
